import actions from './actions';
import { initialValues } from '@iso/schemasAndValidations/Plan';
const initState = {
  isLoading: false,
  errorMessage: false,
  plans: [],
  modalActive: false,
  plan: initialValues
};

export default function reducer(state = initState, { type, payload }) {
  switch (type) {
    case actions.LOAD_FROM_API:
      return {
        ...state,
        errorMessage: false,
        modalActive: false
      };
    case actions.LOAD_FROM_API_SUCCESS:
      return {
        ...state,
        plans: payload.data,
        errorMessage: false
      };
    case actions.LOAD_FROM_API_ERROR:
      return {
        ...state,
        errorMessage: 'There is a loading problem'
      };
    case actions.TOGGLE_API_HANDLE_MODAL:
      return {
        ...state,
        modalActive: !state.modalActive,
        plan: payload.data == null ? initState.plan : payload.data
      };
    case actions.UPDATE_PLAN_FEATURE:
      return {
        ...state,
        plan: payload.data
      };
    case actions.TABLE_HANDLER:
      return {
        ...state,
        isState: payload.data
      };
    case actions.TOGGLE_LOADING:
      return {
        ...state,
        isLoading: payload.value
      };
    default:
      return state;
  }
}
